import { ViewModel, View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { isEmailValid, stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsBoolean, getAsNumber } from "src/uicomponents/components/utilities";
import { MediaSelector } from "uicomponents";
import { RequestCreationView } from "./requestCreation-view"
import { RequestCreationPhoneView } from "./requestCreationPhone/requestCreationPhone-view";

export class RequestCreationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("requestCreation-viewModel.requestRegistration", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.workTypes = ObservableArray.create<workTypes>();
        this.workTypes.update(...[
            new workTypes(this, "1", translate("requestCreation-viewModel.wholesale", {})),
            new workTypes(this, "2", translate("requestCreation-viewModel.singleSell", {})),
            new workTypes(this, "3", translate("requestCreation-viewModel.repairman", {}))
        ]);
        this.province = new ProvinceSelector(this);
        this.citySelector = new CitySelector(this);
        this.province.onSelectionChanged = x => {
            this.citySelector.provinceId = x?.id;
            this.citySelector.requestRefresh();
            this.provinceName = x?.title ?? '';
        }
        this.citySelector.onSelectionChanged = x => {
            this.cityName = x?.title ?? '';
        }
        this.isSent = false;
        this.monthesExpreince = 0;
        this.area = 0;
        this.warehouseArea = 0;
    }
    closePopup(result: any) {
    }
    GetDefaultView(): View<ViewModel> {
        return MediaSelector.GetView({
            desktop: () => new RequestCreationView(),
            default: () => new RequestCreationPhoneView()
        })
        return new RequestCreationView();
    }
    public getTypeId(): string {
        return "VM-50A36AD9-8174-4A1F-BD3F-ABEC7136B0EA"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set isJuridical(v: boolean) { this._isJuridical = v; } public get isJuridical(): boolean { return this._isJuridical; } private _isJuridical: boolean;
    public set naturalPersonName(v: string) { this._naturalPersonName = v; } public get naturalPersonName(): string { return this._naturalPersonName; } private _naturalPersonName: string;
    public set naturalPersonLastName(v: string) { this._naturalPersonLastName = v; } public get naturalPersonLastName(): string { return this._naturalPersonLastName; } private _naturalPersonLastName: string;
    public set naturalPersonBirthDate(v: moment.Moment) { this._naturalPersonBirthDate = v; } public get naturalPersonBirthDate(): moment.Moment { return this._naturalPersonBirthDate; } private _naturalPersonBirthDate: moment.Moment;
    public set naturalpersonNationalCode(v: string) { this._naturalpersonNationalCode = v; } public get naturalpersonNationalCode(): string { return this._naturalpersonNationalCode; } private _naturalpersonNationalCode: string;

    public set juridicalPersonCompanyName(v: string) { this._juridicalPersonCompanyName = v; } public get juridicalPersonCompanyName(): string { return this._juridicalPersonCompanyName; } private _juridicalPersonCompanyName: string;
    public set juridicalPersonCreationDate(v: moment.Moment) { this._juridicalPersonCreationDate = v; } public get juridicalPersonCreationDate(): moment.Moment { return this._juridicalPersonCreationDate; } private _juridicalPersonCreationDate: moment.Moment;
    public set juridicalPersonIdentificationCode(v: string) { this._juridicalPersonIdentificationCode = v; } public get juridicalPersonIdentificationCode(): string { return this._juridicalPersonIdentificationCode; } private _juridicalPersonIdentificationCode: string;

    public set cellPhone(v: string) { this._cellPhone = v; } public get cellPhone(): string { return this._cellPhone; } private _cellPhone: string;
    public set phone(v: string) { this._phone = v; } public get phone(): string { return this._phone; } private _phone: string;
    public set email(v: string) { this._email = v; } public get email(): string { return this._email; } private _email: string;

    public set province(v: ProvinceSelector) { this._province = v; } public get province(): ProvinceSelector { return this._province; } private _province: ProvinceSelector;
    public set citySelector(v: CitySelector) { this._citySelector = v; } public get citySelector(): CitySelector { return this._citySelector; } private _citySelector: CitySelector;

    public set yearsExperience(v: number) { this._yearsExperience = getAsNumber(v, true); } public get yearsExperience(): number { return this._yearsExperience; } private _yearsExperience: number;
    public set monthesExpreince(v: number) { this._monthesExpreince = getAsNumber(v, true); } public get monthesExpreince(): number { return this._monthesExpreince; } private _monthesExpreince: number;

    public set workTypes(v: ObservableArray<workTypes>) { this._workTypes = v; } public get workTypes(): ObservableArray<workTypes> { return this._workTypes; } private _workTypes: ObservableArray<workTypes>;
    public set selectedWorkType(v: workTypes) { this._selectedWorkType = v; } public get selectedWorkType(): workTypes { return this._selectedWorkType; } private _selectedWorkType: workTypes;

    public set CashBuy(v: boolean) { this._CashBuy = getAsBoolean(v); } public get CashBuy(): boolean { return this._CashBuy; } private _CashBuy: boolean;
    public set credit(v: number) { this._credit = getAsNumber(v, true); } public get credit(): number { return this._credit; } private _credit: number;

    public set ownership(v: boolean) { this._ownership = getAsBoolean(v); } public get ownership(): boolean { return this._ownership; } private _ownership: boolean;
    public set businessLicense(v: boolean) { this._businessLicense = getAsBoolean(v); } public get businessLicense(): boolean { return this._businessLicense; } private _businessLicense: boolean;

    public set area(v: number) { this._area = getAsNumber(v, true); } public get area(): number { return this._area; } private _area: number;
    public set hasWarehouse(v: boolean) { this._hasWarehouse = getAsBoolean(v); } public get hasWarehouse(): boolean { return this._hasWarehouse; } private _hasWarehouse: boolean;
    public set warehouseArea(v: number) { this._warehouseArea = getAsNumber(v, true); } public get warehouseArea(): number { return this._warehouseArea; } private _warehouseArea: number;

    public set smsCode(v: string) { this._smsCode = v; } public get smsCode(): string { return this._smsCode; } private _smsCode: string;
    public set isSent(v: boolean) { this._isSent = v; } public get isSent(): boolean { return this._isSent; } private _isSent: boolean;

    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName; } private _cityName: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName; } private _provinceName: string;
    public set readLaw(v: boolean) { this._readLaw = v; } public get readLaw(): boolean { return this._readLaw; } private _readLaw: boolean;


    sendSms() {
        this.isSent = true;
    }

    async confirm() {
        let validationResult = this.validate();
        if (validationResult.length > 0) {
            await this.messageBoxConfirmWarning(validationResult.join('\n'), translate("requestCreation-viewModel.enteringError", {}));
        } else {
            let popup = new confirmationPopup(this);
            popup.popup = this;
            let result = await this.requestShowingPopup(popup);
        }
    }
    validate(): string[] {
        let result: string[] = [];
        if (this.isJuridical == false) {
            if (stringIsNullOrEmpty(this.naturalPersonName)) {
                result.push(translate("requestCreation-viewModel.nameError", {}));
            }
            if (stringIsNullOrEmpty(this.naturalPersonLastName)) {
                result.push(translate("requestCreation-viewModel.lastNameError", {}));
            }
            if (this.naturalPersonBirthDate == null) {
                result.push(translate("requestCreation-viewModel.birthDateError", {}));
            }
            if (stringIsNullOrEmpty(this.naturalpersonNationalCode)) {
                result.push(translate("requestCreation-viewModel.nationalCodeError", {}));
            }
        } else {
            if (stringIsNullOrEmpty(this.juridicalPersonCompanyName)) {
                result.push(translate("requestCreation-viewModel.nameError", {}));
            }
            if (this.juridicalPersonCreationDate == null) {
                result.push(translate("requestCreation-viewModel.registrationDateError", {}));
            }
            if (stringIsNullOrEmpty(this.juridicalPersonIdentificationCode)) {
                result.push(translate("requestCreation-viewModel.nationalID", {}));
            }
        }
        if (stringIsNullOrEmpty(this.cellPhone) || this.cellPhone.length != 11) {
            result.push(translate("requestCreation-viewModel.mobileNumberError", {}));
        }
        if (stringIsNullOrEmpty(this.phone) == false && this.phone.length != 11) {
            result.push(translate("requestCreation-viewModel.mobileAndCodeError", {}));
        }
        if (stringIsNullOrEmpty(this.email) == false && isEmailValid(this.email) == false) {
            result.push(translate("requestCreation-viewModel.emailError", {}));
        }
        if (this.province.selectedItem == null) {
            result.push(translate("requestCreation-viewModel.provinceError", {}));
        }
        if (this.citySelector.selectedItem == null) {
            result.push(translate("requestCreation-viewModel.cityError", {}));
        }
        if (this.yearsExperience == null || this.yearsExperience < 0) {
            result.push(translate("requestCreation-viewModel.yearError", {}));
        }
        if (this.monthesExpreince == null || (this.monthesExpreince < 0 || this.monthesExpreince > 12)) {
            result.push(translate("requestCreation-viewModel.monthError", {}));
        }
        if (this.selectedWorkType == null) {
            result.push(translate("requestCreation-viewModel.activityFieldError", {}));
        }
        if (this.credit == null || this.credit <= 0) {
            result.push(translate("requestCreation-viewModel.averageMonthlyPurchaseError", {}));
        }
        if (this.area == null || this.area < 0) {
            result.push(translate("requestCreation-viewModel.storeSizeError", {}));
        }
        if (this.hasWarehouse && (this.warehouseArea == null || this.warehouseArea < 0)) {
            result.push(translate("requestCreation-viewModel.warehouseSizeError", {}));
        }
        return result;
    }

    async create() {
        try {
            this.isLoading = true;
            let context = {
                isJuridical: this.isJuridical,
                naturalPersonName: this.naturalPersonName,
                naturalPersonLastName: this.naturalPersonLastName,
                naturalPersonBirthDate: this.naturalPersonBirthDate,
                naturalpersonNationalCode: this.naturalpersonNationalCode,
                juridicalPersonCompanyName: this.juridicalPersonCompanyName,
                juridicalPersonCreationDate: this.juridicalPersonCreationDate,
                juridicalPersonIdentificationCode: this.juridicalPersonIdentificationCode,
                cellPhone: this.cellPhone,
                phone: this.phone,
                email: this.email,
                province: this.province.selectedItem.id,
                citySelector: this.citySelector.selectedItem.id,
                provinceName: this.provinceName,
                cityName: this.cityName,
                yearsExperience: this.yearsExperience,
                monthesExpreince: this.monthesExpreince,
                selectedWorkType: this.selectedWorkType.id,
                workTypeName: this.selectedWorkType.name,
                CashBuy: this.CashBuy,
                credit: this.credit,
                ownership: this.ownership,
                businessLicense: this.businessLicense,
                area: this.area,
                hasWarehouse: this.hasWarehouse,
                warehouseArea: this.warehouseArea,
                name: (this.naturalPersonName ?? '') + ' ' + (this.naturalPersonLastName ?? '') + (this.juridicalPersonCompanyName ?? ''),
                relatedDate: this.naturalPersonBirthDate ?? this.juridicalPersonCreationDate,
                nationalCode: this.naturalpersonNationalCode ?? this.juridicalPersonIdentificationCode
            };

            let result = await ServerConnection.callServer('/Complex/IndominServices/CreateRequest', {
                ProcessId: '696987B3-D0F2-408B-A79E-A8D89F42F108',
                Context: JSON.stringify(context)
            });
            if (result.IsSuccessful) {

            }
            await this.messageBoxConfirmSuccess(translate("requestCreation-viewModel.operationSuccessfully", {}), translate("requestCreation-viewModel.successfulOperation", {}));
            location.reload();

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class confirmationPopup extends ViewModel implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }
    closePopup(result: any) {
    }

    public set popup(v: RequestCreationViewModel) { this._popup = v; } public get popup(): RequestCreationViewModel { return this._popup; } private _popup: RequestCreationViewModel;

    back() {
        this.closePopup(null);
    }
    async confirm() {
        await this.popup.create();
        this.closePopup(true);
    }
}

export class workTypes extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel, id: string, name: string) {
        super(parent);
        this.id = id;
        this.name = name;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;

}

export class ProvinceSelector extends SelectorBaseViewModel<province> {
    protected async loadData(): Promise<province[]> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/GeographicalRegionRawDataServices/GetAllProvinces', {
            });
            return result.Provinces.map(x => {
                let r = new province(this);
                r.id = x.Id;
                r.title = x.Name;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<province[]>([]);
        } finally {
            this.isLoading = false;
        }
    }
}
export class province extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}

export class CitySelector extends SelectorBaseViewModel<city> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel, true);


    }
    protected async loadData(): Promise<city[]> {
        if (stringIsNullOrEmpty(this.provinceId))
            return Promise.resolve<city[]>([]);
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/GeographicalRegionRawDataServices/GetAllCitiesInProvince', {
                ProvinceId: this.provinceId
            });
            return result.Cities.map(x => {
                let r = new province(this);
                r.id = x.Id;
                r.title = x.Name;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<city[]>([]);
        } finally {
            this.isLoading = false;
        }
    }

    public set provinceId(v: string) {
        if (this.provinceId != v) {
            this._provinceId = v;
            this.requestRefresh();

        }

    } public get provinceId(): string { return this._provinceId; } private _provinceId: string;

}
export class city extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}
